// extracted by mini-css-extract-plugin
export default {"customFormContainer":"CustomForm_customFormContainer__BLzwM","submitButtonContainer":"CustomForm_submitButtonContainer__lgre9"};